<template>
  <div class="big">
    <div class="page_title">医生分享管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox wrap">
          <div class="item">
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 200px; margin: 0 12px 0 8px"
              clearable=""
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_phone"
              style="width: 200px; margin: 0 12px 0 8px"
              clearable=""
            ></el-input>
          </div>
          <div class="item">
            <span>业务员姓名</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_name"
              style="width: 200px; margin: 0 30px 0 8px"
              clearable=""
            ></el-input>
          </div>
          <div class="item">
            <span>业务员手机</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_phone"
              style="width: 200px; margin: 0 12px 0 8px"
              clearable=""
            ></el-input>
          </div>
          <div class="item">
            <span>已有分享渠道</span>
            <el-select
              style="width: 160px; margin-left: 12px"
              v-model="from_id"
              placeholder="请选择"
            >
              <el-option
                :label="item.from_name"
                :value="item.from_id"
                v-for="(item, index) in shareFromData"
                :key="index"
              >
              </el-option>
            </el-select>
            <el-button
              type="info"
              @click="search"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 30px;
              "
              >查询</el-button
            >
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6; margin-top: 12px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
          >
            <el-table-column prop="doctor_name" label="医生信息">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.doctor_name }}</span>
                  <span v-if="scope.row.sex == 1" style="margin-left: 16px"
                    >男</span
                  >
                  <span v-if="scope.row.sex == 2" style="margin-left: 16px"
                    >女</span
                  >
                </div>
                <div>
                  <span>{{ scope.row.doctor_phone }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="所在省市">
              <template slot-scope="scope">
                <span>{{ scope.row.province }}</span>
                <span>{{ scope.row.city }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hospital" label="医院名称"></el-table-column>
            <el-table-column prop="doctor_name" label="业务员信息">
              <template slot-scope="scope">
                <div>{{ scope.row.recommender_name }}</div>
                <div>{{ scope.row.recommender_code }}</div>
                <div>{{ scope.row.recommender_phone }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="count"
              label="关注人数"
              sortable="custom"
            ></el-table-column>
            <el-table-column prop="from" label="分享渠道"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1145')
                      : false
                  "
                  @click="toDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: "",
      doctor_phone: "",
      recommender_name: "",
      recommender_phone: "",
      order_by: "",
      shareFromData: [],
      from_id: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        from_id: this.from_id,
        sort: this.order_by,
      };
      this.axios
        .post("platform/Doctor/getDoctorShareList", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            let list = res.data.list;
            this.tableData = list;
            this.totalNum = res.data.total;
          }
        });
    },
    getShareFromData() {
      this.axios.post("platform/Admin/getShareFromData").then((res) => {
        this.shareFromData = [
          {
            from_id: "",
            from_name: "全部",
          },
          ...res.data.value,
        ];
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    changeOrder(value) {
      this.prop = value.prop;
      //升序
      if (value.order == "ascending") {
        this.order_by = "asc";
      }
      //降序
      if (value.order == "descending") {
        this.order_by = "desc";
      }
      if (!value.order) {
        this.prop = "";
        this.order_by = "";
      }
      this.getList();
    },
    //详情
    toDetail(row) {
      this.$router.push({
        name: "sharedetail",
        query: {
          doctor_id: row.doctor_id,
        },
      });
    }, //评价展示开关
  },
  activated() {
    this.getList();
    this.getShareFromData();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  .item {
    margin-bottom: 20px;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>
